import request from '@/utils/request'

export function getRecruitmentList() {
    return request({
        url: '/hbgwOnstage/nav/recruitment',
        method: 'get'
    })
}